import { GatsbyLink, GatsbyLinkProps } from "@mgdx-libs/link";
import { cx } from "cva";

import { SubtleButtonProps, variants } from ".";
import styles from "./index.module.css";
export const SubtleButtonBulletLink = ({
  className,
  children,
  align,
  radius,
  width,
  disabled,
  onClick,
  ...props
}: Readonly<SubtleButtonProps & Omit<GatsbyLinkProps<Record<never, never>>, "ref">>) => (
  <GatsbyLink
    aria-disabled={disabled}
    className={cx(styles.bullet, variants({ align, radius, width }), className)}
    tabIndex={disabled ? -1 : undefined}
    onClick={disabled ? (event) => event.preventDefault() : onClick}
    {...props}
  >
    <span className="flex items-start">
      <span aria-hidden={true} className={styles.bulletMarker} />
      {children}
    </span>
  </GatsbyLink>
);
